import { definePreset, palette } from '@primeuix/themes';

//Mögliuche themes predefined in primeng
import Material from '@primeuix/themes/material'; // okay


// Farben hier --> https://primeng.org/theming


// #8843: Tokens teils flach geschrieben (z. B. checkbox.disabled.background) – erzeugen dieselben CSS-Variablen
// wie die typisierten Pfade (geprüft in LiefPreset.spec.ts), passen aber nicht zu den Typen von @primeuix/themes.
const Lieferantenportalpreset = definePreset(Material, <any>{

  components: {

    checkbox:
    {
      // #8843: Material-Pfad – der flache Pfad erzeugt dieselbe Variable, unter PrimeNG 20 gewinnt aber der Basiswert
      root: {
        //#7863
        disabledBackground: '{slate.400}',
      }
    },

    dialog:
    {
      header:
      {
        padding: 'var(--paddingControlLarge)',
        gap: 'var(--gapControlSmall)',
      },
      // #8843: oben 0.5rem statt 0 (Material) - gleicht den negativen Rand einer PrimeFlex-.grid am Inhaltsanfang
      // aus, sonst wird der Inhalt 0.5rem zu hoch und bekommt einen Scrollbalken
      content:
      {
        padding: '0.5rem {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}',
      },
      // #9672: content.hover.background statt surface-100 - im Hellen derselbe Wert (surface.100), im Dark Mode
      // surface.800 (slate, blau-grau); surface-100 ist in beiden Modi slate.100, der Dialogkopf war dort weiß (z. B. "Novität Einkauf").
      // Das css unter semantic.colorScheme.dark.dialog wirkt nicht.
      css: ({ dt }) => `
              .p-dialog-header {
                  background: var(--p-content-hover-background);
              }
              `,



    },
    inputgroup: {
      addon:
      {
        padding: 'var(--paddingControlSmall)',
      },
    },
    textarea: {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
    },
    inputtext: {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
    },
    autocomplete:
    {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
    },
    multiselect:
    {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
      option: {
        padding: 'var(--paddingControlSmall)',
      },
      list: {
        padding: 'var(--paddingControlSmall)',
        header: {
          padding: 'var(--paddingControlSmall)',
        }
      }
    },
    select: {


      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
      option: {
        padding: 'var(--paddingControlSmall)',
      },
      list: {
        padding: 'var(--paddingControlSmall)',
        header: {
          padding: 'var(--paddingControlSmall)',
        }
      }
    },
    tree: {
      padding: 'var(--paddingControlSmall)',
      node: {
        padding: 'var(--paddingControltiny)',
      }
    },
    // #8843: Sortier-Icon der TreeTable wie unter PrimeNG 19 (1rem), eigener Token neben datatable
    treetable: {
      sortIcon: {
        size: '1rem',
      },
    },
    datatable:
    {

      // #8843: header.cell.padding entfernt – war unter PrimeNG 19 wirkungslos (Standard 0.75rem 1rem),
      // würde ab PrimeNG 20 erstmals greifen (kompakter Tabellenkopf). Optisch neutrales Upgrade, siehe Phase 3.
      // #8843: Sortier-Icon wie unter PrimeNG 19 (p-icon 1rem, Textfarbe des Kopfes); PrimeNG 20 färbt es mit sortIcon.color
      sortIcon: {
        size: '1rem',
        color: '{text.color}',
      },
      // #8843: Material-Pfad – der flache Pfad erzeugt dieselbe Variable, unter PrimeNG 20 gewinnt aber der Basiswert
      bodyCell: {
        padding: 'var(--paddingControlCell)',
      },
      css: ({ dt }) => `
              .p-datatable.p-datatable-striped .p-datatable-tbody > tr:nth-child(odd):not(.p-datatable-row-selected) {
    .p-datatable-frozen-column
  {
      background: ${dt('datatable.row.striped.background')};
  }
}

.p-datatable-hoverable
  .p-datatable-tbody
  > tr:not(.p-datatable-row-selected):hover {
  .p-datatable-frozen-column {
    background: ${dt('datatable.row.hover.background')};
  }
}
                `,

      colorScheme: {
        light: {
          // datatable
          header:
          {
            cell: {
            }
          }
        },
        dark:
        {
          border:
          {
            color: '{slate.750}',
          },
          row: {
            background: '{slate.900}',
            color: '{slate.50}',
            hover:
            {
              background: '{sky.300}',
              color: '{slate.950}',
            }
          },
          body: {
            cell: {
              padding: 'var(--paddingControlCell)',
              border:
              {
                color: '{slate.700}'
              }
            }
          },
          header:
          {
            background: '{slate.700}',
            color: '{slate.100}',
            border:
            {
              color: '{slate.400}'
            },
            cell: {
              padding: 'var(--paddingControlCell)',
              hover:
              {
                background: '{sky.300}',
                color: '{slate.950}',
              },
              background: '{slate.900}',
              color: '{slate.50}',
              border:
              {
                color: '{slate.700}'
              }
            }
          },
          footer:
          {
            background: '{slate.700}',
            color: '{slate.0}',
            cell: {
              padding: 'var(--paddingControlCell)',
              background: '{slate.700}',
              color: '{slate.0}',
              border:
              {
                color: '{slate.700}'
              }
            }
          }
        }
      }
    },
    paginator:
    {
      // #8843: Material-Pfad – der flache Pfad erzeugt dieselbe Variable, unter PrimeNG 20 gewinnt aber der Basiswert
      root: {
        background: '{slate.50}'
      },
      // #9672: slate.50 galt auch im Dark Mode - der Paginator war dort weiß (z. B. unter "Novitäteneinkauf WuP"),
      // semantic.colorScheme.dark.paginator verliert gegen diese Komponenten-Tokens
      colorScheme: {
        dark: {
          root: {
            background: '{slate.700}'
          },
          navButton: {
            color: '{slate.200}',
            hoverColor: '{slate.50}'
          }
        }
      }
    },
    panel:
    {
      header: {
        background: '{slate.50}',
        padding: 'var(--paddingControlSmall)',
      },
      // #9672: slate.50 galt auch im Dark Mode - der Kopf war dort fast weiß, die helle Schrift darauf unlesbar
      colorScheme: {
        dark: {
          header: {
            background: '{slate.700}',
            color: '{slate.100}',
          }
        }
      }
    },
    toolbar:
    {
      root: {
        padding: 'var(--paddingControlSmall)',
        gap: 'var(--gapControlSmall)',
      },
      background: '{slate.100}',
    },
    menubar:
    {
      // #8843: Material-Pfad – der flache Pfad erzeugt dieselbe Variable, unter PrimeNG 20 gewinnt aber der Basiswert
      root: {
        background: '{slate.100}',
      },
      submenu:
      {
        background: '{slate.50}',
      },
      // #9672: slate.100/slate.50 galten auch im Dark Mode - die helle Schrift war darauf nicht lesbar,
      // semantic.colorScheme.dark.menubar verliert gegen diese Komponenten-Tokens
      colorScheme: {
        dark: {
          root: {
            background: '{slate.900}',
          },
          submenu: {
            background: '{slate.900}',
          }
        }
      }
    },

    accordion:
    {
      header: {
        background: '{slate.100}',
        hover:
        {
          background: '{slate.200}',
        },
        active:
        {
          background: '{slate.100}',
          hover:
          {
            // background: '{slate.200}',
          },
        }
      },
      // #9672: slate.100/slate.200 galten auch im Dark Mode - die Köpfe waren dort hell, die helle Schrift
      // darauf unlesbar; semantic.colorScheme.dark.accordion verliert gegen diese Komponenten-Tokens
      colorScheme: {
        dark: {
          header: {
            background: '{slate.800}',
            hoverBackground: '{slate.600}',
            activeBackground: '{slate.800}',
          }
        }
      }
    },
    // #9672: Buttons im Dark Mode wie im hellen Modus (semantic.colorScheme.light.primary: blue.600, weiße Schrift,
    // blue.800 beim Hovern) - sonst hellblau-violett (indigo.400) mit dunkler Schrift (Kontrast 3.7)
    button: {
      colorScheme: {
        dark: {
          root: {
            primary: {
              background: '{blue.600}',
              hoverBackground: '{blue.800}',
              activeBackground: '{blue.600}',
              borderColor: '{blue.600}',
              hoverBorderColor: '{blue.800}',
              activeBorderColor: '{blue.600}',
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff',
            }
          }
        }
      }
    },
    togglebutton: {
      root:
      {
        padding: 'var(--paddingControlSmall)',
      },

      colorScheme: {
        light: {
          root:
          {
            padding: 'var(--paddingControlMedium)',
            // #8843: Material-Pfad – der flache Pfad erzeugt dieselbe Variable, unter PrimeNG 20 gewinnt aber der Basiswert
            checkedBackground: '{blue.100}',
          },
          sm:
          {
            padding: 'var(--paddingControlSmall)',

          },
          lg:
          {
            padding: 'var(--paddingControlMedium)',
          },
          background: '{surface.200}',
          border: {
            color: '{blue.600}'
          },
          checked:
          {
            border: {
              color: '{blue.300}'
            }
          }
        },
        dark: {

          background: '{slate.700}',
          color: '{blue.50}',
          icon: {
            color: '{slate.50}',
            checked:
            {
              color: '{slate.50}',
            },
            hover:
            {
              color: '{blue.200}',
            }
          },
          hover:
          {
            color: '{blue.50}',
            background: '{slate.700}',
          },
          checked:
          {
            color: '{blue.300}',
            background: '{slate.700}'
          }
        }
      },
    }
  },
  semantic: {

    colorScheme: {
      light: {
         formField: {

          disabled:
          {
            //#7863 vor allem wegen Filter
            background :  '{slate.100}',
            // color: '{slate.800}',
          }

        },



        primary: {
          disabledBackground: '{green.0}',
          color: '{blue.600}',
          inverseColor: '#ffffff',
          hoverColor: '{blue.800}',
          activeColor: '{blue.600}'
        },
        highlight: {
          background: '{blue.500}',
          focusBackground: '{blue.300}',
          color: '#ffffff',
          focusColor: '#ffffff'
        }

      },
      dark: {
        autocomplete:
        {
          background: '{slate.800}',
          color: '{slate.50}',
          option:
          {
            background: '{slate.700}',
            color: '{slate.50}',
            border: {
              color: '{slate.500}',
            },
            focus:
            {
              background: '{slate.800}',
              color: '{blue.50}',
            }
          },
          overlay:
          {
            background: '{slate.800}',
            color: '{slate.50}',
            border: {
              color: '{slate.500}',
            },
            content:
            {
              background: '{slate.700}',
              color: '{slate.50}',
            }
          },
          empty:
          {
            message: {
              background: '{zinc.800}',
              color: '{zinc.0}',
            }
          }
        },
        popover:
        {
          background: '{zinc.800}',
          color: '{zinc.0}',
          border:
          {
            color: '{slate.500}'
          },
          content:
          {

          }
        },
        inputgroup:
        {
          background: '{slate.900}',
          color: '{slate.50}',
          addon:
          {
            background: '{zinc.800}',
            color: '{slate.0}',
            border:
            {
              color: '{slate.800}',
            }
          }
        },
        formField: {
          hoverBorderColor: '{primary.color}',
          color: '{slate.50}',
          background: '{slate.900}',
        },

        text: {

        },

        components: {

          formgroup:
          {
            background: '{slate.800}',
            color: '{slate.50}',
          },
          form: {
            field: {
              hoverBorderColor: '{primary.color}',
              color: '{slate.50}',
              background: '{slate.900}',
            }
          },

          inputgroup:
          {
            background: '{slate.900}',
            color: '{slate.50}',
          },
            card:
          {
            background: '{slate.600}',
            color: '{slate.50}',
            border:
            {
              color: '{slate.400}',
            }
          },
          splitter:
          {
            background: '{slate.800}',
            color: '{slate.50}',
            border:
            {
              color: '{slate.800}',
            }
          },
          tabs:
          {
            tab:
            {
              color: '{slate.950}',
              background: '{slate.500}'
            },
            tablist: {
              color: '{slate.50}',
              background: '{slate.700}'
            },
            tabpanel:
            {
              color: '{slate.50}',
              background: '{slate.700}'
            }
          },
          fileupload:
          {
            background: '{slate.900}',
            color: '{slate.50}',
          },
          treeselect:
          {
            background: '{slate.900}',
            color: '{slate.50}',

          },
          tree:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            node: {
              hover: {
                background: '{slate.500}',
              },
              background: '{slate.900}',
              color: '{slate.50}',
              content: {
                background: '{slate.900}',
                color: '{slate.50}',

              }
            }
          },
          inputnumber:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            placeholder:
            {
              color: '{slate.300}',
            }
          },
          inputtext:
          {
            background: '{slate.900}',

            color: '{slate.50}',
            placeholder:
            {
              background: '{slate.800}',
              color: '{slate.300}',
            },
            disabled:
            {
              background: '{slate.850}',
              color: '{slate.100}',
            }
          },
          paginator:
          {
            background: '{slate.700}',
            color: '{surface.0}',
            nav: {
              button: {
                color: '{slate.0}',
                background: '{slate.700}',
                hover: {
                  background: '{slate.500}',
                }
              }
            },
            current:
            {
              nav: {
                button: {
                  color: '{slate.50}',
                  background: '{slate.500}',
                  hover: {

                  }

                }
              },
              page:
              {
                report: {
                  color: '{slate.50}'
                }
              }
            }



          },
          datepicker:
          {
            color: '{surface.50}',
            header:
            {
              background: '{slate.300}',

            },
            day: {
              background: '{surface.700}',
              color: '{surface.0}'
            },
            month: {
              background: '{surface.700}',
              color: '{surface.0}'
            },
            year: {
              background: '{surface.700}',
              color: '{surface.0}'
            },
            dropdown:
            {
              background: '{slate.700}',
              color: '{surface.50}',
              active:
              {
                background: '{zinc.500}',
                color: '{zinc.50}',
              }
            }

          },
          textarea:
          {
            background: '{slate.900}',
            color: '{slate.50}',
          },





          select:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            Overlay:
            {
              background: '{slate.800}',
              color: '{slate.50}',
            },
            placeholder:
            {
              background: '{slate.800}',
              color: '{slate.50}',
            },
            item:
            {
              background: '{slate.900}',
              color: '{slate.0}',
            },
            option:
            {
              focus:
              {
                background: '{slate.600}',
                color: '{slate.50}',
              },
              background: '{slate.900}',
              color: '{slate.0}',
              selected:
              {
                background: '{slate.800}',
                color: '{slate.0}',

              }
            }


          },
          multiselect:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            label:
            {
              background: '{slate.900}',
              color: '{slate.50}'
            },
            placeholder:
            {
              color: '{slate.100}',
              background: '{slate.900}',
            },
            Overlay:
            {
              background: '{slate.800}',
              color: '{slate.50}',
            },
            item:
            {
              background: '{slate.900}',
              color: '{slate.0}',
              hover:
              {
                background: '{slate.500}',
                color: '{slate.0}',
              }
            },
            option:
            {
              background: '{slate.900}',
              color: '{slate.0}',
              focus:
              {
                background: '{slate.600}',
                color: '{slate.50}',
              },
              selected:
              {
                background: '{slate.800}',
                color: '{slate.0}',
              }
            }

          },
          dialog:
          {
            background: '{zinc.600}',
            color: '{zinc.50}',
            border:
            {
              color: '{zinc.700}',
            },
            css: ({ dt }) => `
              .p-dialog-header {
                  background: var(--p-surface-600);
              }
              `
          },
          treetable:
          {
            body: {
              cell:
              {
                padding: 'var(--paddingControlCell)',
                background: '{zinc.700}',
                color: '{zinc.50}',
                border: {
                  color: '{slate.500}',
                },
                hover:
                {
                  background: '{zinc.200}',
                  color: '{zinc.900}',
                }
              }
            },
            row:
            {
              background: '{zinc.700}',
              color: '{zinc.50}',
              hover:
              {
                background: '{zinc.200}',
                color: '{zinc.900}',
              }
            },
            header: {
              background: '{zinc.700}',
              color: '{zinc.50}',
              cell:
              {
                padding: 'var(--paddingControlCell)',
                background: '{zinc.700}',
                color: '{zinc.50}'
              }
            }
          },

          checkbox:
          {
            background: '{zinc.400}',
          },
          radiobutton:
          {
            background: '{zinc.400}',
          },

          toolbar:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            border:
            {
              color: '{slate.700}',
            },
          },
          menubar:
          {
            border:
            {
              color: '{slate.700}',
            },
            background: '{slate.900}',
            color: '{slate.50}',
            label:
            {
              background: '{slate.700}',
              color: '{slate.50}',
            },
            item:
            {
              background: '{slate.900}',
              color: '{slate.50}',
              focus:
              {
                background: '{slate.600}',
                color: '{slate.50}',
              },
              label:
              {
                background: '{slate.700}',
                color: '{slate.50}',
              }
            },
            submenu:
            {
              background: '{slate.900}',
              border:
              {
                color: '{slate.700}',
              },
              color: '{slate.50}',
              list:
              {
                background: '{slate.900}',
                color: '{slate.50}',
                border:
                {
                  color: '{slate.700}',
                },
              }
            }
          },
          panel:
          {
            background: '{slate.700}',
            color: '{slate.100}',

            border: {
              color: '{slate.700}'
            },
            header:
            {
              background: '{slate.700}',
              color: '{slate.100}',
              border: {
                color: '{slate.700}'
              }
            }
          },
          button: {

          },
          accordion:
          {
            header: {
              color: '{slate.100}',
              background: '{slate.800}',
              hover:
              {
                color: '{slate.100}',
                background: '{slate.600}',
              },
              active:
              {
                color: '{slate.100}',
                background: '{slate .700}',
                hover:
                {
                  color: '{slate.100}',
                  background: '{slate.500}',
                },
              }

            },
            content: {
              color: '{slate.50}',
              background: '{slate.900}'
            }
          },
        },
        navigation: {
          list: {
            background: '{slate.900}',
            color: '{slate.50}',
          },
          item: {
            background: '{slate.900}',
            color: '{slate.50}',
          },
          submenuLabel: {
            background: '{slate.800}',
            color: '{slate.50}',
          },
          submenuIcon: {
            background: '{slate.700}',
            color: '{slate.50}',
            hover:
            {
              color: '{blue.50}',
            }
          }
        },

        root: {
          editBackground: '{green.950}',
          background: '{surface.950}',
          checkedBackground: '{surface.850}',
          hoverBackground: '{surface.800}',
          borderColor: '{surface.900}',
          color: '{surface.50}',
          hoverColor: '{surface.500}',
          checkedColor: '{surface.0}',
          checkedBorderColor: '{surface.800}',

        },
        primary: palette('{indigo}'),
        highlight: {
          background: 'rgba(250, 250, 250, .16)',
          focusBackground: 'rgba(250, 250, 250, 0.5)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)'
        },
        surface: {
          0: 'rgba(255,255,255,.87)',
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          850: '{slate.850}',
          900: '{slate.900}',
          950: '{slate.950}'
        },
      }

    }
  }



});



export default Lieferantenportalpreset;


